// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyActivateWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, UserPropertyActivateResponseWebDto } from '../..';

interface ActivateParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyActivateWebApiHandler_activate_Path = '/api/web/v1/users/properties/activate';

/**
 * Activate a property
 */
export const RentalManagerUserPropertyActivateWebApiHandler_activate = (
  getParams: ActivateParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ActivateParams, never, UserPropertyActivateResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyActivateWebApiHandler_activate_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
